<script setup>
import { decoratorProps } from '@/mixin/props'
import { defineProps, defineEmits } from 'vue'

defineEmits(decoratorProps.emits)
defineProps({
  ...decoratorProps.props,
})
</script>
<template>
  <div v-if="row.is_fake == undefined">
    <div v-if="row.user_id !== null" class="tag-decorator">
      {{ headCell.tag_value }}
    </div>
    <div v-if="row.user_id == null" class="tag-decorator-userEmpty">
      {{ headCell.tag_empty }}
    </div>
  </div>
</template>
